import { PropsWithChildren } from 'react'
import Styles from './ScrollContainer.module.scss'

const ScrollContainer = ({ children }: PropsWithChildren) => <div className={Styles.scrollContainer}>{children}</div>

export { ScrollContainer }
